import { Moment } from 'moment';

export const disabledStartDate = (
  current: Moment,
  validator: Moment | undefined,
): boolean => {
  return validator ? current && current.isAfter(validator, 'date') : false;
};

export const disabledDueDate = (
  current: Moment,
  validator: Moment | undefined,
): boolean => {
  return validator ? current && current.isBefore(validator, 'date') : false;
};
